import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	siteSurveysRestCrudThunksForBuyer,
	siteSurveysRestCrudThunksForSupplier,
} from '../../thunks/site_surveys_thunks';
import { goBackLink } from '../../utils/HistoryUtils';
import { withUserType } from '../withUserType';
import { getSSLocationsByTitleAndTemplate } from '../../thunks/site_surveys_grouped_thunks';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { message } from 'antd';
import SiteSurveyBulkUpdateForm from '../site_survey_form/SiteSurveyBulkUpdateForm';

const EditSiteSurveyPage: FC<any> = ({
	getSiteSurvey,
	getSiteSurveyLocations,
	siteSurvey,
	history,
	location,
	userType,
}): React.ReactElement => {
	const [locationLoading, setLocationsLoading] = useState(false);
	const [allLocations, setAllLocations] = useState([]);

	const { title: siteSurveyTitle, templateId: siteSurveyTemplateId } = useParams<{
		title: string;
		templateId: string;
	}>();
	const urlPath = `/${userType}/siteSurveys/byTitle/${siteSurveyTitle}/template/${siteSurveyTemplateId}/locations`;

	useEffect(() => {
		setLocationsLoading(true);
		getSiteSurveyLocations(siteSurveyTitle, siteSurveyTemplateId)
			.then((locations) => {
				setAllLocations(locations);
				if (nullSafeGet('0.siteSurveyId', locations)) {
					getSiteSurvey(nullSafeGet('0.siteSurveyId', locations))
						.catch(message.error)
						.finally(() => setLocationsLoading(false));
				}
			})
			.catch((err) => {
				message.error(err);
				setLocationsLoading(false);
			});
	}, [siteSurveyTemplateId, siteSurveyTitle]);

	return (
		<>
			<EditPage
				title="Edit Site Survey"
				formComponentProps={{
					formData: {
						...siteSurvey,
						ids: allLocations.map((_) => _.siteSurveyId),
						locationIds: allLocations.map((_) => _.locationId),
					},
					onSuccess: (rec) => {
						history.push(goBackLink(location, urlPath));
					},
				}}
				fetching={locationLoading}
				FormComponent={SiteSurveyBulkUpdateForm}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	siteSurvey: state.site_surveys.detail,
	siteSurveys: state['site_surveys/locationandwalkthrough'],
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSiteSurvey: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveysRestCrudThunksForSupplier.readOne(id)
				: siteSurveysRestCrudThunksForBuyer.readOne(id)
		),
	getSiteSurveyLocations: (title, templateId) =>
		dispatch(getSSLocationsByTitleAndTemplate(ownProps.userType)(title, templateId)),
});

export default withUserType(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(EditSiteSurveyPage as any)) as any
);
